import { Container } from "react-bootstrap";
import PaymentDetails from "./PaymentDetails";
import OrderDetails from "./OrderDetails";
import PaymentButton from "./PaymentButton";
import TermsSwitch from "./TermsSwitch";
import ProFormaButton from "./ProFormaButton";
import PromoCodeMessage from "./PromoCodeMessage";

const Product = ({ product, promoCodeMessage }) => {

    if (product !== null) {


        return (
            <Container fluid="md py-5">
                <PromoCodeMessage promoCodeMessage={promoCodeMessage} />
                <PaymentDetails />
                <OrderDetails product={product} />
                <TermsSwitch />
                <PaymentButton product={product} />
                <ProFormaButton product={product} />    
            </Container>
        );
    }
}

export default Product;